import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LegacyTicketBookingSettings } from '../../models/serializable/legacy-ticket-booking-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LegacyTicketBookingSettingsComponent extends Component {
  static readonly TYPE_ID: string = '7172147766a84b0584a5018a30c1a69c';

  constructor(
    public readonly settings: LegacyTicketBookingSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return LegacyTicketBookingSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LegacyTicketBookingSettingsComponent {
    return new LegacyTicketBookingSettingsComponent(
        context.fromData<LegacyTicketBookingSettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new LegacyTicketBookingSettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: LegacyTicketBookingSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class LegacyTicketBookingSettingsComponentBuilder extends DataModelBuilder<LegacyTicketBookingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): LegacyTicketBookingSettingsComponent {
    return LegacyTicketBookingSettingsComponent.fromMap(context, map);
  }
}
